export const default_reserve = {
  borrower: "",
  type: "",
  sub_type: "",
  bank_name: "",
  account_number: "",
  funds: "0"
};
